const internalSiteIndex = (state = 0, action) => {
    switch(action.type) {
        case 'internalSiteIndex':
            return action.payload;
        default:
            return state;
    }
}

export default internalSiteIndex;